import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { ExposedAPI } from "../../apis/ExposedAPI";
import { URL_REDIRECT } from "../../constant/url";
import { slugify } from "../../utils/utils";

export default function UnderSubCategoryRedirect() {
  const { undersubcategory } = useParams();
  const [categorieState, setCategorieState] = useState(null);
  const [subcategorieState, setSubCategorieState] = useState(null);
  const [undersubcategorieState, setUnderSubCategorieState] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    loadCategory(undersubcategory);
  }, [undersubcategory]);

  const loadCategory = (undersubcategoryId) => {
    ExposedAPI.getDistantOrStoredCategories()
      .then((categories) => {
        let undersubCategory;
        loop: for (let c of categories) {
          for (let sc of c.subCategories) {
            for (let usc of sc.underSubCategories) {
              if (usc.id + "" === undersubcategoryId + "") {
                undersubCategory = usc;
                setSubCategorieState(sc);
                setCategorieState(c);
                break loop;
              }
            }
          }
        }

        if (!undersubCategory) {
          setNotFound(true);
          return;
        }
        setUnderSubCategorieState(undersubCategory);
      })
      .catch((err) => {
        setNotFound(true);
        console.log(err);
      });
  };

  if (notFound) return <div>Sous sous catégorie introuvable</div>;
  if (undersubcategorieState)
    return (
      <Navigate
        to={`${URL_REDIRECT.categorie}${slugify(
          categorieState.label
        )}/${slugify(subcategorieState.label)}/${slugify(
          undersubcategorieState.label
        )}`}
        replace
      />
    );

  return <div>Redirection...</div>;
}
